import type { IActionableOrderSummary } from "@agrigate/shared/lib/services/NotificationService";
import { atom, useAtom } from "jotai";
import rpc from "../utils/rpc";

export const actionableOrdersAtom = atom<IActionableOrderSummary>({});

export const useActionableOrders = () => {
    const [orders, setOrders] = useAtom(actionableOrdersAtom);

    const refresh = async () => {
        setOrders(await rpc.notification.findActionableOrders());
    };

    return {
        orders,
        refresh,
    };
};
